import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'savechangesconfirmation',
  templateUrl: 'savechanges-confirmation.component.html',
  styleUrls: ['savechanges-confirmation.component.scss'],
})
export class savechangesconfirmationComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() submessage: string;  
  @Input() projectCSS: boolean = false;
  @Input() closeMessage: string;
  @Output() confirmBoxHandler: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();

  constructor() {}

  ngOnInit() {
    console.log('save called');
      console.log(this.message);
  }

  closeConfirmationBox(status: boolean) {
      console.log('confirmBoxHandler', status);
    this.confirmBoxHandler.emit(status);
  }
}
